// import $ from "jquery"
import ReCAPTCHA from "react-google-recaptcha"

import { useForm } from "react-hook-form"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { ApiData, ExceptionCodes, getApiDataPromise } from "../../models/ApiData"
import { ExchangeSession } from "../../models/ExchangeSession"
import { ExClient } from "../../models/ExClient"
import OptionsApiData from "../common/OptionsApiData"
import { TermsAndConditionsLabel } from "../exchange/TermsAndConditionsLabel"
import { EmailVerifyModal } from "../login/EmailVerifyModal"

export default function CorporateForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const history = useHistory()
  const onSubmit = async function (data: any) {
    data["g-recaptcha-response"] = $('[name="g-recaptcha-response"]').val()

    if (!data["g-recaptcha-response"]) {
      toast.error("Please fill out the reCAPTCHA!")
      return
    }

    if (data.password !== data.password2) {
      toast.error("Your password and confirmation password do not match!")
      return
    }

    // data.shop_id = ExClient.shop_id

    //this.props.history.push('/main');
    var result = await getApiDataPromise(data, "client", "register_company")

    if (result.success) {
      toast.success("Registered!")
      await ExClient.sendRegEvent("register")
      ExchangeSession.email_temp = data.email

      history.push("/login?email=" + data.email + "#registered")
    } else {
      toast.error(result.message)

      if (result.code === ExceptionCodes.CAPTCHA_CODE) {
        // @ts-ignore
        grecaptcha.reset()
      }
    }
  }

  const onCountriesLoaded = () => {
    ApiData.clientApiRequest({}, "get_country").then((data) => {
      if (data.success) $("#country_code").val(data.data["code"])
    })
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="steps__form">
          <div className="steps__form_boxing">
            <div className="register_form">
              <>
                <>
                  <div className="form__item">
                    <input
                      type="text"
                      className="input input_small"
                      placeholder="Company Name"
                      {...register("company_name", {
                        required: true,
                        minLength: 2,
                        pattern: /^[a-zA-Z\s]*$/,
                      })}
                    />
                    {errors.first_name &&
                      (errors.first_name.type === "pattern" ? (
                        <span className="erorrs">This field should be in Latin letters!</span>
                      ) : (
                        <span className="erorrs">This field is required!</span>
                      ))}
                  </div>
                </>
                <>
                  <div className="form__item">
                    <span style={{ position: "absolute", marginTop: -16, fontSize: 12, opacity: 0.5 }}>Company Registration Country</span>
                    <select id="country_code" className="input select_light input_small " {...register("country_code", { required: true })}>
                      <OptionsApiData type={"country"} key_equals_value={false} onLoaded={onCountriesLoaded} />
                    </select>
                    {errors.country && <span className="erorrs">This field is required!</span>}
                  </div>
                </>
              </>

              <div className="form__item">
                <input
                  id={"email"}
                  type="text"
                  className={"input input_small" + (errors.email ? "  field-erorrs" : "")}
                  placeholder="Company Email"
                  {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
                />
                {errors.email && <span className="erorrs">Please enter a valid email!</span>}
              </div>
              <div className="form__item">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="State"
                  {...register("state", { required: true, minLength: 2 })}
                />
                {errors.state && <span className="erorrs">This field is required!</span>}
              </div>
              <div className="form__item">
                <input
                  type="tel"
                  className="input input_small"
                  placeholder="Phone"
                  {...register("phone", {
                    required: true,
                    pattern: /^[0-9+]{1,}[0-9-]{5,15}$/,
                  })}
                />
                {errors.phone && <span className="erorrs">Please enter a valid phone!</span>}
              </div>
              <div className="form__item">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="City"
                  {...register("city", { required: true, minLength: 2 })}
                />
                {errors.city && <span className="erorrs">This field is required!</span>}
              </div>
              <div className="form__item">
                <input
                  id={"email"}
                  type="text"
                  className={"input input_small" + (errors.email ? "  field-erorrs" : "")}
                  placeholder="Business Website"
                  {...register("site", { required: true })}
                />
                {errors.email && <span className="erorrs">Please enter a valid email!</span>}
              </div>

              <div className="form__item form__item_nolabel">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="Street Address"
                  {...register("address", { required: true, minLength: 2 })}
                />
                {errors.address && <span className="erorrs">This field is required!</span>}
              </div>

              <div className="form__item">
                <input
                  type="password"
                  className="input input_small"
                  placeholder="Password"
                  {...register("password", { required: true, minLength: 6 })}
                />
                <img src="/img/see.svg" alt="see" className="in_password" />
                {errors.password && <span className="erorrs">This field is required!</span>}
              </div>
              <div className="form__item form__item_nolabel">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="Apt/Suite"
                  {...register("address2", { required: false, minLength: 2 })}
                />
                {errors.address2 && <span className="erorrs">This field is required!</span>}
              </div>
              <div className="form__item">
                <input
                  type="password"
                  className="input input_small"
                  placeholder="Repeat Password"
                  {...register("password2", { required: true, minLength: 6 })}
                />
                <img src="/img/see.svg" alt="see" className="in_password" />
                {errors.password2 && <span className="erorrs">This field is required!</span>}
              </div>

              <div className="form__item form__item_nolabel">
                <input
                  type="text"
                  className="input input_small"
                  placeholder="Zip Code"
                  {...register("zip", { required: true, minLength: 2 })}
                />
                {errors.zip && <span className="erorrs">This field is required!</span>}
              </div>
            </div>

            <div className="step__box_agree">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="agree"
                  defaultChecked={false}
                  {...register("agree_terms", { required: true })}
                />
                <TermsAndConditionsLabel />
                {errors.agree_terms && <span className="erorrs ml-five">Please accept Terms &amp; Conditions!</span>}
              </div>
            </div>
            <div className="step__box_agree">
              <div className="custom-control custom-checkbox">
                <input id="agree_risk" type="checkbox" className="custom-control-input" {...register("agree_risk", { required: true })} />
                <label className="custom-control-label" htmlFor="agree_risk">
                  I accept{" "}
                  <a href="risk_disclosure.html" target="_blank">
                    Risk disclosure
                  </a>
                </label>
                {errors.agree_risk && <span className="erorrs ml-five">Please accept Risk disclosure!</span>}
              </div>
            </div>
            <div className="step__box_agree">
              <div className="custom-control custom-checkbox">
                <input
                  id="agree_policy"
                  type="checkbox"
                  className="custom-control-input"
                  defaultChecked={false}
                  {...register("agree_policy", { required: true })}
                />
                <label className="custom-control-label" htmlFor="agree_policy">
                  I accept{" "}
                  <a href="refund_cancellation_policy.html" target="_blank">
                    Refund and Cancellation policy
                  </a>
                </label>
                {errors.agree_policy && <span className="erorrs ml-five">Please accept Refund and Cancellation policy!</span>}
              </div>
            </div>
            <div className="step__box_agree">
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="old"
                  defaultChecked={false}
                  {...register("agree_age", { required: true })}
                />
                <label className="custom-control-label" htmlFor="old">
                  I confirm that I am 18 years old
                </label>
                {errors.agree_age && <span className="erorrs ml-five">Please accept that you are over 18 years old!</span>}
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <ReCAPTCHA sitekey="6LcK4UIrAAAAAIyxjMXq8Xyf09FzdY2Y2M_zstuc" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="steps__form_footer">
                <button type="submit" className="button button_bg_red steps-form__submit">
                  Register
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <EmailVerifyModal />
    </>
  )
}
